<template>
    <div>
        <avue-data-box :option="icons"></avue-data-box>
        <div>
            <div id="c2" style="width: 25%;;display: inline-block"></div>
            <div id="c1" style="width: 50%;display: inline-block"></div>
            <div id="c0" style="width: 25%;;display: inline-block"></div>

        </div>
    </div>
</template>

<script>
  import {Chart} from '@antv/g2';

  export default {
    name: "Home",
    data() {
      return {
        icons: {
          span: 6,
          data: [{
            title: '今日注册',
            count: 12678,
            icon: 'el-icon-tickets',
            color: 'rgb(49, 180, 141)',
          }, {
            title: '今日登录',
            count: 22139,
            icon: 'el-icon-success',
            color: 'rgb(56, 161, 242)',
          }, {
            title: '今日订阅',
            count: 35623,
            icon: 'el-icon-info',
            color: 'rgb(117, 56, 199)',
          },
            {
              title: '今日评论',
              count: 16826,
              icon: 'el-icon-message',
              color: 'rgb(117, 56, 199)',
            }
          ]
        }
      }
    },
    mounted() {
      // c1
      const chartC1 = new Chart({
        container: 'c1',
        autoFit: true,
        height: 350,
      });

      chartC1.data([
        {date: '2020-05-01', value: 3},
        {date: '2020-05-02', value: 4},
        {date: '2020-05-03', value: 3.5},
        {date: '2020-05-04', value: 5},
        {date: '2020-05-05', value: 100},
      ]);
      // 度量定义
      chartC1.scale({
        date: {
          type: 'time',
          mask: 'MM-DD',
          nice: true,
          alias: '日期',
        },
        value: {
          min: 0,
          nice: true,
          alias: 'App访问量',
        },
      });
      chartC1.tooltip({
        showCrosshairs: true, // 展示 Tooltip 辅助线
        shared: true,
      });
      chartC1.line().position('date*value').label('value');
      chartC1.point().position('date*value');
      chartC1.render();

      // c2
      const chartC2 = new Chart({
        container: 'c2',
        autoFit: true,
        height: 350,
      });

      chartC2.coordinate('theta', {
        radius: 0.75,
      });

      chartC2.data([
        {item: '支付宝', percent: 0.625},
        {item: '微信', percent: 0.25},
        {item: '其他', percent: 0.125},
      ]);

      chartC2.scale('percent', {
        formatter: (val) => {
          val = val * 100 + '%';
          return val;
        },
      });


      chartC2.interval().position('percent').color('item').label('percent', {
        content: (data) => {
          return `${data.item}: ${data.percent * 100}%`;
        },
      }).adjust('stack');
      chartC2.interaction('element-active');
      chartC2.render();
    }
  }
</script>
